import React, {useEffect, useState} from "react";
import PropTypes from "prop-types";
import {useHistory} from "react-router-dom";
// Layout
import Wrapper from "../../../Chat/Layout/Wrapper/Wrapper";
import MessagerieWrapper from "../../../Chat/Layout/MessagerieWrapper/MessagerieWrapper";
import ContainerMessagerie from "../../../Chat/Layout/ContainerMessage/ContainerMessagerie";
// Composants
import ChatTitle from "../../../Chat/shared/ChatTitle/ChatTitle";
import ColoneChatInfos from "../../../Chat/shared/ColoneChatInfos/ColoneChatInfos";
// Container
import Modal from "../../../../containers/Home/Pages/YourQuestions/Modal";
// Assets
import Accept from "../../../../assets/icons/accept.svg";
import Refuse from "../../../../assets/icons/refuse.svg";
import Nav from "../../../../containers/Nav/Nav";

const YourQuestions = ({
                           getQuestionsAnswers,
                           updateResponse,
                           updateQuestion,
                           question
                       }) => {

    const [showModal, setShowModal] = useState(false);
    const [questionId, setQuestionId] = useState(null);
    const [openFreeQuestionChatBot, setOpenFreeQuestionChatBot] = useState(true);
    const [displayQuestions, setDisplayQuestions] = useState(true);
    useEffect(() => {
        const getQuestionsThenUpdate = async () => {
// Récupère les questions du user et les réponse des CareManager
            await getQuestionsAnswers();
// updateResponse permet de vérifier les réponses non lues (state = 0)
// et de les marquer comme lues (state = 1)
            updateResponse();
        };
        getQuestionsThenUpdate();
    }, []);

    const history = useHistory();

    const handleShowModal = (id) => {
        setShowModal(true);
// Set l'id de la question pour pouvoir l'identifier dans la requête API mettant à jour le status de la question
        setQuestionId(id);
    };
    if (question) {
        return (
            <>
                <Wrapper>
                    <Nav
                        setDisplayQuestions={setDisplayQuestions}
                    />
                    <MessagerieWrapper>
                        <ChatTitle caremanagerName="Prev&Care" rdv onclick={() => history.push("/")}/>
                        <ContainerMessagerie>
                            <div>
                                <div className={"bulle-gauche fade"}>
                                    <div className={"bulleMessage bulleUser fade"}>
                                        Question : {question.content}
                                    </div>
                                </div>
                                {question.reponses && question.reponses.map((r, index) =>
// On affiche les réponses du Care Manager
                                        <>
                                            <div key={index} className={"bulle-droite fade"}>
                                                <div className={"bulleMessage bulleCareManager fade"}>
                                                    Réponse : {r.content}
                                                </div>
                                            </div>
                                            {question.state === "0" &&
                                                // Si le question.state est sur 0 cela veut dire que le user n'a pas encore donnée son avis sur la question
                                                // Une fois son avis donnée on ne veut plus afficher cette partie
                                                <div key={index} className={"bulle-droite fade"}>
                                                    <div className="bulle-document">
                                                        <div>
                                                            <div className="contenu-doc">
                                                                {/*<img src={Pap} alt="Devis"/>*/}
                                                                <div>
                                                                    <h1>Est-ce que cette réponse est satisfaisante ? </h1>
                                                                    <h2></h2>
                                                                </div>
                                                            </div>
                                                            <div className="proposition">
                                                                <button className="acceptDevis"
                                                                        onClick={() => updateQuestion(question.id, 99)}><img
                                                                    src={Accept} alt="Accepter"/></button>
                                                                <button className="refuseDevis"
                                                                        onClick={() => handleShowModal(question.id)}><img
                                                                    src={Refuse} alt="Refuser"/></button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                        </>
                                )}
                            </div>
                        </ContainerMessagerie>
                    </MessagerieWrapper>
                    <ColoneChatInfos rappel={false} enableDocument={false}
                                     openFreeQuestionChatBot={openFreeQuestionChatBot}/>
                </Wrapper>
                {showModal &&
                    // Affichage du composant modal pour que le user donne son avis sur la réponse
                    <Modal
                        showModal={showModal}
                        setShowModal={setShowModal}
                        questionId={questionId}
                    />
                }
            </>
        );
    }
};

YourQuestions.propTypes = {
    question: PropTypes.object,
    getQuestionsAnswers: PropTypes.func,
    updateResponse: PropTypes.func,
    updateQuestion: PropTypes.func,
};

export default YourQuestions;
